const KEY = 'muscuapp_offline_queue';

// Écritures rejouables hors ligne : séries, notes de séance, mesures corporelles
const QUEUEABLE = [/^\/sessions\/\d+\/sets(\/\d+)?$/, /^\/sessions\/\d+$/, /^\/body(\/\d+)?$/];

export const isQueueable = (method, path) =>
  method !== 'GET' && QUEUEABLE.some((re) => re.test(path.split('?')[0]));

export const isNetworkError = (err) => err instanceof TypeError;

function read() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (_) { return []; }
}

function write(queue) {
  localStorage.setItem(KEY, JSON.stringify(queue));
  window.dispatchEvent(new CustomEvent('muscuapp:queue', { detail: queue.length }));
}

export const pendingCount = () => read().length;

export function enqueue(entry) {
  write([...read(), { ...entry, queuedAt: Date.now() }]);
}

export function clearQueue() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent('muscuapp:queue', { detail: 0 }));
}

let flushing = false;

// Rejoue la file dans l'ordre ; s'arrête dès que le réseau est de nouveau indisponible
export async function flushQueue(send) {
  if (flushing) return 0;
  flushing = true;
  let sent = 0;
  try {
    let queue = read();
    while (queue.length) {
      const [head, ...rest] = queue;
      try {
        await send(head);
      } catch (err) {
        if (isNetworkError(err)) break;
        // Erreur serveur (ex. séance supprimée) : on abandonne cette écriture
      }
      sent++;
      queue = rest;
      write(queue);
    }
  } finally {
    flushing = false;
  }
  if (sent) window.dispatchEvent(new CustomEvent('muscuapp:synced'));
  return sent;
}
